export const SUBMISSION_ERROR_MESSAGE =
  'Something went wrong. Please try again.';
